export const testimonials = {
  title: "Lo que dicen las familias",
  subtitle: "Testimonios de nuestra comunidad educativa",
  items: [
    {
      quote: "Gándara combina los principios Montessori con flexibilidad, respeto y alegría. Nuestros hijos se sienten felices, seguros y curiosos cada día, y afrontamos el futuro con total tranquilidad.",
      author: "Alba & Marc",
      role: "Familia Gándara"
    },
    {
      quote: "Buscábamos un colegio Montessori, internacional y donde nuestras hijas fueran felices. En Gándara encontramos todo eso y mucho más.",
      author: "Patri & Pablo",
      role: "Familia Gándara"
    },
    {
      quote: "Gándara es un lugar seguro donde los niños crecen respetados y acompañados. El equipo docente es sensible y entiende de verdad a cada niño.",
      author: "Marie",
      role: "Familia Gándara"
    }
  ]
};
